import { isTagPrivate, RecordValue, SpecialTagTypeEnum } from "libs/schema";
import { renderStaticJsxToString } from "./renderStaticJsxToString";

function renderGroupName(group: RecordValue<"tag">): string {
  let name = [group.icon, group.name].filter(Boolean).join(" ");

  if (group.archived_at) {
    name += " (Archived)";
  }

  return name;
}

export function getMessageContentForSubscriptionNotification(props: {
  user: RecordValue<"user_profile">;
  tag: RecordValue<"tag">;
}) {
  const { user, tag } = props;

  const isPrivate = isTagPrivate(tag);
  const tagType = tag.type === SpecialTagTypeEnum.GROUP ? "group" : "tag";

  return renderStaticJsxToString(
    <>
      <p>
        Hi{" "}
        <span data-type="mention" data-id={user.id} data-label={user.name} data-subject="user" data-priority="300">
          @{user.name}
        </span>
        ,
      </p>
      <p></p>
      <p>
        I've subscribed you to the{isPrivate ? " private " : " "}
        <a href={`/${tagType}s/${tag.id}`}>{renderGroupName(tag)}</a> {tagType}.
      </p>
    </>,
  );
}
